// Angular
import { Directive, Input, ElementRef, Renderer2, HostListener, HostBinding, AfterViewInit } from '@angular/core';
import { OnInit } from '@angular/core';

@Directive({
    selector: '[autoResize]'
})

export class AutoResizeDirective implements OnInit {
    @HostListener('input', ['$event.target'])
    onInput(textArea: HTMLTextAreaElement): void {
        this.adjust();
    }

    constructor(public element: ElementRef) {
    }

    public adjust(): void {
        const textArea = this.element.nativeElement;
        if (textArea.scrollHeight > 0) {
            textArea.style.overflow = 'hidden';
            textArea.style.height = 'auto';
            textArea.style.height = textArea.scrollHeight + 'px';
        }
    }

    ngOnInit(): void {
        setTimeout(() => this.adjust(), 0);
    }
}
